// Sample businesses for the booking page replica (components/story/StoryBookingStage.vue). All
// people, prices and links are invented. Each page tells its own story, so each has its own sample.
// The page strings around them are the public booking page's own (workspace-public-website
// locales/booking/en.json); the shape follows what the API supports (Workspace369-API
// functions-schedules publicBooking): per-service intake questions, a deposit or full payment
// through Stripe Checkout, Google busy time removing slots, a Google Meet location and the
// workspace's after-payment page. Facts: handoffs/2026-10-21-web-design-lead/review/booking/FACTS.md.

export type BookingSample = {
  business: string;
  initials: string;
  path: string;
  services: { name: string; minutes: number; price: string }[];
  pick: number;
  host: string;
  date: string;
  slots: string[];
  busy: { title: string; time: string; slots: string[] };
  time: string;
  client: { name: string; first: string; email: string };
  intake: { label: string; value: string; kind: "text" | "select" }[];
  total: string;
  dueNow: string;
  afterPayment: { note: string; button: string };
};

export const bookingSamples: Record<string, BookingSample> = {
  // /features/schedule: a small design studio with a paid workshop.
  studio: {
    business: "Fernway Studio",
    initials: "FS",
    path: "369.dev/ws/f3RnW7/book/workshops",
    services: [
      { name: "Brand workshop", minutes: 90, price: "$450" },
      { name: "Website review", minutes: 45, price: "$180" },
      { name: "Content plan session", minutes: 60, price: "$240" },
    ],
    pick: 0,
    host: "Maya Chen",
    date: "Thursday 29 October",
    slots: ["9:00", "9:30", "10:00", "11:30", "1:00", "1:30", "2:00", "3:30"],
    busy: { title: "School pickup", time: "1:00 – 2:30 PM", slots: ["1:00", "1:30", "2:00"] },
    time: "10:00",
    client: { name: "Jordan Ellis", first: "Jordan", email: "jordan@harborline.test" },
    intake: [
      { label: "What should the workshop cover?", value: "New logo and colours for our café", kind: "text" },
      { label: "Team size", value: "2–10", kind: "select" },
    ],
    total: "$450",
    dueNow: "$225",
    afterPayment: { note: "Thanks, Jordan. Before Thursday, send us three brands you like.", button: "Open the prep checklist" },
  },
  // /solutions/scheduling-software-for-consultants: a consultant's paid strategy session on Google Meet.
  consultant: {
    business: "Northwind Advisory",
    initials: "NA",
    path: "369.dev/ws/n7Qe2x/book/strategy",
    services: [
      { name: "Strategy session", minutes: 60, price: "$300" },
      { name: "Follow-up call", minutes: 30, price: "$150" },
      { name: "Board prep session", minutes: 90, price: "$450" },
    ],
    pick: 0,
    host: "Priya Raman",
    date: "Tuesday 3 November",
    slots: ["9:00", "9:30", "10:00", "10:30", "1:00", "1:30", "2:00", "4:00"],
    busy: { title: "Board meeting", time: "1:00 – 2:30 PM", slots: ["1:00", "1:30", "2:00"] },
    time: "10:00",
    client: { name: "Sam Okafor", first: "Sam", email: "sam@brightlane.test" },
    intake: [
      { label: "What decision are you working on?", value: "Pricing for our new service line", kind: "text" },
      { label: "Annual revenue", value: "$1M–$5M", kind: "select" },
    ],
    total: "$300",
    dueNow: "$150",
    afterPayment: { note: "Thanks, Sam. Please share last quarter's numbers before we meet.", button: "Upload your documents" },
  },
};
